import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { transformNameToUrl } from "../../../helpers/transform-name-to-url";
import { Router } from "@angular/router";


@Component({
    selector: 'gen-bundle-carousel-item',
    templateUrl: './bundle-carousel-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenBundleCarouselItemComponent {
  @Input() product: any;

  transformNameToUrl = transformNameToUrl;

  constructor(private router: Router) {
  }

  navigateToProduct() {
    this.router.navigate(['product', this.product.code, transformNameToUrl(this.product.name)]);
  }

}
